export const BUILD_VERSION = '1790026961';
